import { Component, OnInit,Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { KitchenStockItemService } from '../../../shared/services/kitchen-stock-item.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { KitchenStockRequirementService } from '../../../shared/services/kitchen-stock-requirement.service';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ngx-add-stock-requirement-items',
  templateUrl: './add-stock-requirement-items.component.html',
  styleUrls: ['./add-stock-requirement-items.component.scss']
})
export class AddStockRequirementItemsComponent implements OnInit {

  itemDetails: any;
  addItemForm: FormGroup;
  showProcessingIndicator = false;
  showCheckQtyMessage = false;

  validationMessages:any = {
    'qty': { 'required': 'This field is required' },
    'totalQty': { 'required': 'This field is required' },
    'unitCost': { 'required': 'This field is required' },
    'totalCost': { 'required': 'This field is required' },
  };

  formErrors:any = { 
    'qty': "",
    'totalQty': "",
    'unitCost': "",
    'totalCost': "",
  };


  constructor(
              @Inject(MAT_DIALOG_DATA) public data:any,
              public dialogRef: MatDialogRef<AddStockRequirementItemsComponent>,
              private kitchenStockItemService : KitchenStockItemService,
              private fb: FormBuilder,
              private toastr: ToastrService,
              private router : Router, 
              private kitchenStockRequirementService: KitchenStockRequirementService,
            ) { }

  ngOnInit(): void {
    this.itemDetails =  this.data;
    this.initializeForm();
    

    this.addItemForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.addItemForm);
     // this.calculateQty(data);
      });

  

  } //nd oninit


  initializeForm(){
    this.addItemForm = this.fb.group({  
      id:  [this.itemDetails.Id, Validators.required], 
      qtyInStock : [this.itemDetails.QtyBal], 
      qty :  ['', Validators.required],  
      totalQty :  ['', Validators.required], 
      unitCost : [this.itemDetails.UnitCost,Validators.required], 
      totalCost :  ['',Validators.required], 
     
   
    });

  }

  
  onClose(){
    this.addItemForm.reset();
    this.dialogRef.close();
   }




  addButtonClick(): void {

    this.logValidationErrors(this.addItemForm,true);
    if (this.addItemForm.valid) {   
       this.data.Qty = this.addItemForm.value.qty;
       this.data.TotalQty = this.addItemForm.value.totalQty;
       this.data.TotalCost  = this.addItemForm.value.totalCost;
      this.kitchenStockRequirementService.orderItems.push(this.data);
      this.onClose();

      } 


  }


  isNumeric(value:any){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }




   calculateQty(){
    let qtyInStock: number;
    let qty: number;
    let totalQty: number;
    let unitCost: number;
    let totalCost: number = 0;

    qtyInStock = this.addItemForm.get('qtyInStock').value ? +this.addItemForm.get('qtyInStock').value : null;
    qty = this.addItemForm.get('qty').value ? +this.addItemForm.get('qty').value : null;
    unitCost = this.addItemForm.get('unitCost').value ? +this.addItemForm.get('unitCost').value : null;
    totalCost = (unitCost && qty) ? +unitCost * +qty : null;
    
    // qtyInStock = data.qtyInStock  ? parseFloat(data.qtyInStock) : null;
    // qty = data.qty  ? parseFloat(data.qty) : null;
    // unitCost = data.unitCost  ? parseFloat(data.unitCost) : null;
    // totalCost = (unitCost && qty) ? +unitCost * +qty : null;

    if(qtyInStock && qty){
      totalQty =(qtyInStock + qty);
    }else if(qtyInStock){
      totalQty = qtyInStock;
    }else if(qty){
      totalQty =qty;
    }else{
      qtyInStock = null;
      qty = null;
      totalQty = null;
    }

    this.addItemForm.patchValue({
      qtyInStock : qtyInStock,
      qty : qty,
      totalQty : totalQty,
      unitCost : unitCost,
      totalCost : totalCost
    })


 
 
   }

   enableForm():void{
    Object.keys(this.addItemForm.controls).forEach(key => {
      this.addItemForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }

   logValidationErrors(group: FormGroup = this.addItemForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.addItemForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  


}
